<div class="sidebar-button-wrapper flex items-center justify-between"
  [class]="selected ? 'selected' : ''">
  <div>
    <i class="icon fal" [class]="'fa-'+icon"></i>
    <span class="ml-3.5">{{text}}</span>
  </div>
  <div *ngIf="number!==''" class="number flex justify-center items-center">{{number}}</div>
</div>